import {CustomFieldComponentProps} from "./FormFieldInterface";
import React, {MutableRefObject, useEffect, useRef, useState} from "react";
import {FormVicinityAddress} from "./FormVicinityAddress";
import {FormVicinity} from "./FormVicinity";
import {Grid, IconButton, Tooltip} from "@mui/material";
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import {NumberProps} from "./FormNumber";
import {JsonIgnore, JsonProperty} from "../../utils/objectmapper/Mapper";
import {Geometry} from "../../../web/model/Geometry";
import {
    useCodeBookControllerContext,
} from "../../../web/raal_components/controller/CodeBookController";
import {useDidMount, useMountedEffect} from "../hooks/SharedHooks";
import {useTranslation} from "react-i18next";
import {exist} from "../../utils/Util";
import {useAppContext} from "../../../web/context/AppContext";
import {
    FormVicinityContainerFilterViewMode,
    useFormVicinityContainerContext
} from "../../../web/context/FormVicinityContainerContext";
import {Waypoint} from "../../../web/model/Waypoint";
import {useTheme} from "@material-ui/core";

export type VicinityOptions = {
    numberProps?: NumberProps
    titleOkoli?: string
    titleRadius?: string
    titleMpz?: string
    titlePsc?: string
    titleNazevMista?: string
    flexDirection?: "column" | "row"
    verticalSpace?: number
    countryCodeForCompare?: () => boolean
    onChange?: (data: Vicinity) => void
    showTitle?: boolean
    filterForm?: boolean
    okoliDisabled?: boolean,
    isDefaultFormVicinityAddress?: boolean,
    isFilterOdkud?:boolean, // true -> jedna se komponentu umistenou v rozsirenem filtru ve filtru Okoli Odkud
    isFilterKam?:boolean // true -> jedna se komponentu umistenou v rozsirenem filtru ve filtru Okoli Kam
    isDokladky?: boolean
    currentNakladkaRadiusRef?: React.MutableRefObject<number | null>
    isEmptyOkoliOdkudLastSearchRef?: React.MutableRefObject<boolean | null>
    isUserSetEmptyOkoliOdkudRef?: React.MutableRefObject<boolean | null>
    currentNakladkaRef?: React.MutableRefObject<Waypoint | null>
    currentVykladkaRadiusRef?: React.MutableRefObject<number | null>
    isEmptyOkoliKamLastSearchRef?: React.MutableRefObject<boolean | null>
    isUserSetEmptyOkoliKamRef?: React.MutableRefObject<boolean | null>
    currentVykladkaRef?: React.MutableRefObject<Waypoint | null>
    currentPrejezdOdWaypointRef?: React.MutableRefObject<Waypoint | null>
    currentPrejezdKamWaypointRef?: React.MutableRefObject<Waypoint | null>
    isPrejezdy?: boolean
    prejezdOdWaypointLastSearchRef?: React.MutableRefObject<Waypoint | null>
    prejezdKamWaypointLastSearchRef?: React.MutableRefObject<Waypoint | null>
    ignoreFocus?: boolean
}

export class Vicinity {
    nazevMista?: string
    countryCode?: string
    @JsonProperty({type: {clazz: Geometry}})
    koordinat?: Geometry
    radius?: number
    psc?: string[]
    mpz?: string[]
    @JsonIgnore({ignoreSet: false, ignoreGet: false})
    osmPlace?: string
}


export type FormVicinityExposed = {
    selectFirstField?: () => void
    onChange?: (v?: Vicinity) => void
}

export type ChildComponentProps = {
    componentRef?: MutableRefObject<FormVicinityExposed>
    getComponentState: () => boolean
}
/**
 * TODO stejná logika jako New, nutné nahradit všude novou novou
 * @param props
 * @constructor
 */
export const FormVicinityContainer = (props: CustomFieldComponentProps<Vicinity, VicinityOptions>) => {
    const vicinityAddressRef = useRef<FormVicinityExposed>();
    const vicinityRef = useRef<FormVicinityExposed>();
    const [showAddress, setShowAddress] = useState(null);
    const {dataGridRef} = useCodeBookControllerContext();
    const options = typeof props.options === 'function' ? props.options() : props.options;
    const {user} = useAppContext();
    const {t} = useTranslation();

    useEffect(() => {
        if (options.ignoreFocus) return;
        if (showAddress) {
            vicinityAddressRef.current?.selectFirstField();
        } else if (!showAddress) {
            vicinityRef.current?.selectFirstField();
        }
        dataGridRef.current?.onRefreshFilterHeaderIndexes();
    }, [showAddress, dataGridRef])

    useDidMount(() => {
        if (props.value) setShowAddress(!exist(props.value?.koordinat));
    })

    useMountedEffect(() => {
        if (props.value && options?.filterForm) setShowAddress(!exist(props.value?.koordinat));
    }, [props.value])

    const switchView = (state: boolean) => {
        setTimeout(() => setShowAddress(state), 1);
    }

    return <Grid container alignItems={"center"} style={{minWidth: 200}}>
        <Grid item lg={10} sm={10} xs={10}>
            {showAddress === false && user.canShowKmFeature() ?
                <FormVicinity {...props} getComponentState={() => !showAddress} componentRef={vicinityRef}/> :
                <FormVicinityAddress {...props} getComponentState={() => showAddress ?? true}
                                     componentRef={vicinityAddressRef}/>}
        </Grid>
        <Grid item container lg={2} sm={2} xs={2} justifyContent={"center"}>
            <Tooltip
                title={user.canShowKmFeature() ? showAddress === false ? t('FormLocalization.Vicinity.Address') : t('FormLocalization.Vicinity.Range') : t('FormLocalization.Vicinity.NoKilom')}>
                    <span>
                        <IconButton size={"small"} color={"default"} disabled={!user.canShowKmFeature()}
                                    onClick={() => switchView(showAddress === null ? false : !showAddress)}>
                            <CompareArrowsIcon/>
                        </IconButton>
                    </span>
            </Tooltip>
        </Grid>
    </Grid>
}

// Dočasná komponenta pro refactor
export const FormVicinityContainerNew = (props: CustomFieldComponentProps<Vicinity, VicinityOptions>) => {
    const vicinityAddressRef = useRef<FormVicinityExposed>();
    const vicinityRef = useRef<FormVicinityExposed>();
    const isDefaultFormVicinityAddressRef = useRef(false); // #4657 - promenna pro sledovani, zda se ma pri opetovnem otevreni rozsireneho filtru u filtru ODKUD nebo KAM zobrazit komponenta FormVicinity (false) nebo FormVicinityAddress (true)
    const [showAddress, setShowAddress] = useState(null);
    // const {dataGridRef} = useCodeBookControllerContextNew();
    const {user} = useAppContext();
    const options = typeof props.options === 'function' ? props.options() : props.options;
    const {t} = useTranslation();
    const {
        formVicinityContainerFilterOdkudViewMode,
        setFormVicinityContainerFilterOdkudViewMode,
        formVicinityContainerFilterKamViewMode,
        setFormVicinityContainerFilterKamViewMode,
    } = useFormVicinityContainerContext();
    const theme = useTheme();

    // props.isPrejezd -> dostupne pokud se komponenta vykresluje z radkoveho filtru
    // props.data?.prejezdOdWaypoint; props.data?.prejezdKamWaypoint -> dostupne pokud se komponenta vykresluje z rozsireneho filtru z Prejezdy
    const isPrejezdy : boolean = !!(props.isPrejezd ||
        props.data?.prejezdOdWaypoint ||
        props.data?.prejezdKamWaypoint);

    // props.isDokladka -> dostupne pokud se komponenta vykresluje z radkoveho filtru
    // props.data?.nakladka; props.data?.vykladka -> dostupne pokud se komponenta vykresluje z rozsireneho filtru z Dokladky
    const isDokladky : boolean = !!(props.isDokladka ||
        props.data?.nakladka ||
        props.data?.vykladka);

    useEffect(() => {
        if (!isPrejezdy && !isDokladky && options.filterForm && options.isFilterOdkud) {
            if (formVicinityContainerFilterOdkudViewMode === "FormVicinity") {
                if (showAddress !== false) {
                    setShowAddress(false);
                }
            } else {
                setFormVicinityContainerFilterOdkudViewMode("FormVicinityAddress");
                if (showAddress !== true) {
                    setShowAddress(true);
                }
            }
        }
    }, [formVicinityContainerFilterOdkudViewMode]);

    useEffect(() => {
        if (!isPrejezdy && !isDokladky && options.filterForm && options.isFilterKam) {
            if (formVicinityContainerFilterKamViewMode === "FormVicinity") {
                if (showAddress !== false) {
                    setShowAddress(false);
                }
            } else {
                setFormVicinityContainerFilterKamViewMode("FormVicinityAddress");
                if (showAddress !== true) {
                    setShowAddress(true);
                }
            }
        }
    }, [formVicinityContainerFilterKamViewMode]);

    useEffect(() => {
        if (options?.isDefaultFormVicinityAddress !== undefined) {
            isDefaultFormVicinityAddressRef.current = options.isDefaultFormVicinityAddress;

            // #4657 - prepnuti, aby se u filtru ODKUD nebo KAM zobrazila komponenta FormVicinityAddress misto komponenty FormVicinity
            if (options.isDefaultFormVicinityAddress && (isPrejezdy || isDokladky)) {
                if (showAddress === false) {
                    setShowAddress(true)
                }
            }
        }
    }, [options?.isDefaultFormVicinityAddress]);

    useEffect(() => {
        if (options.ignoreFocus) return;
        if (showAddress) {
            vicinityAddressRef.current?.selectFirstField();
        } else if (!showAddress) {
            vicinityRef.current?.selectFirstField();
        }
    }, [showAddress])

    // useEffect(() => {
    //     if (showAddress) {
    //         vicinityAddressRef.current?.selectFirstField();
    //     } else if (!showAddress) {
    //         vicinityRef.current?.selectFirstField();
    //     }
    //     dataGridRef.current?.onRefreshFilterHeaderIndexes();
    // }, [showAddress, dataGridRef])

    // Prejezdy + Dokladky :
    // Pri zadani prvotneho filtra zobraz MPZ/PSC
    // Pri zadani MPZ/PSC v riadku filter ostan pri MPZ/PSC
    // Prepravy ostavaju
    useDidMount(() => {
        if (isPrejezdy || isDokladky) {
            if (props.value?.koordinat) {
                if (props.value) setShowAddress(exist(props.value?.koordinat));
            } else {
                if (props.value) setShowAddress(!exist(props.value?.koordinat));
            }
        } else {
            setShowAddress(!exist(props.value?.koordinat))
            if (props.isFilterOdkud) {
                const newFilterViewMode: FormVicinityContainerFilterViewMode = !exist(props.value?.koordinat) ? "FormVicinityAddress" : "FormVicinity";
                setFormVicinityContainerFilterOdkudViewMode(newFilterViewMode)
            }
            if (props.isFilterKam) {
                const newFilterViewMode: FormVicinityContainerFilterViewMode = !exist(props.value?.koordinat) ? "FormVicinityAddress" : "FormVicinity";
                setFormVicinityContainerFilterKamViewMode(newFilterViewMode)
            }
        }
    })

    // Zakomentovane v 4616 - spravanie ohandlovane v useDidMount
    // useMountedEffect(() => {
    //     if (props.value && options?.filterForm) setShowAddress(exist(props.value?.koordinat) && props.isPrejezd);
    // }, [props.value])

    const switchView = (state: boolean) => {
        setTimeout(() => setShowAddress(state), 1);
        const newFilterViewMode: FormVicinityContainerFilterViewMode = state ? "FormVicinityAddress" : "FormVicinity";
        if (!isPrejezdy && !isDokladky) {
            if (props.isFilterRow) { // ovlivnuje filtry v radkovem filtru
                if (props.isFilterOdkud) {
                    setFormVicinityContainerFilterOdkudViewMode(newFilterViewMode)
                } else if (props.isFilterKam) {
                    setFormVicinityContainerFilterKamViewMode(newFilterViewMode)
                }
            } else if (options.filterForm) { // ovlivnuje filtry v rozsirenem filtru
                if (options.isFilterOdkud) {
                    setFormVicinityContainerFilterOdkudViewMode(newFilterViewMode)
                } else if (options.isFilterKam) {
                    setFormVicinityContainerFilterKamViewMode(newFilterViewMode)
                }
            }
        }
    }

    return <Grid container alignItems={"center"} style={{minWidth: 200}}>
        <Grid item lg={10} sm={10} xs={10}>
            {showAddress === false && user.canShowKmFeature() ?
                <FormVicinity {...props} getComponentState={() => !showAddress} componentRef={vicinityRef}/> :
                <FormVicinityAddress {...props} getComponentState={() => showAddress ?? true}
                                     componentRef={vicinityAddressRef}/>}
        </Grid>
        <Grid item container lg={2} sm={2} xs={2} justifyContent={"center"}>
            <Tooltip
                title={user.canShowKmFeature() ? showAddress === false ? t('FormLocalization.Vicinity.Address') : t('FormLocalization.Vicinity.Range') : t('FormLocalization.Vicinity.NoKilom')}>
                    <span>
                        <IconButton size={"small"} color={"default"} disabled={!user.canShowKmFeature()}
                                    style={{color: theme.palette.type === 'dark' ? "#90caf9" : undefined}}
                                    onClick={() => {
                                        switchView(showAddress === null ? false : !showAddress);
                                        props.updateIndexes&&props.updateIndexes();
                                    }}>
                            <CompareArrowsIcon/>
                        </IconButton>
                    </span>
            </Tooltip>
        </Grid>
    </Grid>
}
